/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gross_SalesInputs */

const en_gross_sales = /** @type {(inputs: Gross_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gross Sales`)
};

const es_gross_sales = /** @type {(inputs: Gross_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventas Brutas`)
};

const fr_gross_sales = /** @type {(inputs: Gross_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventes brutes`)
};

const de_gross_sales = /** @type {(inputs: Gross_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruttoumsatz`)
};

const id_gross_sales = /** @type {(inputs: Gross_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjualan Kotor`)
};

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const ja_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const zh_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const ar_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const it_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const ru_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const pt_gross_sales = en_gross_sales;

/** @type {(inputs: Gross_SalesInputs) => LocalizedString} */
const ko_gross_sales = en_gross_sales;

/**
* | output |
* | --- |
* | "Gross Sales" |
*
* @param {Gross_SalesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gross_sales = /** @type {((inputs?: Gross_SalesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gross_SalesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gross_sales(inputs)
	if (locale === "es") return es_gross_sales(inputs)
	if (locale === "fr") return fr_gross_sales(inputs)
	if (locale === "de") return de_gross_sales(inputs)
	if (locale === "ja") return ja_gross_sales(inputs)
	if (locale === "zh") return zh_gross_sales(inputs)
	if (locale === "ar") return ar_gross_sales(inputs)
	if (locale === "id") return id_gross_sales(inputs)
	if (locale === "it") return it_gross_sales(inputs)
	if (locale === "ru") return ru_gross_sales(inputs)
	if (locale === "pt") return pt_gross_sales(inputs)
	return ko_gross_sales(inputs)
});